export default {
  namespaced: true,

  state: {
    hasData: false,
    current: false,
    ticketForm: false,
    list: [],
    updateKey: 0,
    isLoading: false,
    currentEngagements: false,
    engagementLoading: false,
  },

  mutations: {
    SET(state, message) {
      state.list = message;
    },

    SHOW_TICKET_FORM(state, bool) {
      state.ticketForm = bool;
    },

    SET_CURRENT(state, ticket) {
      state.current = ticket;
    },

    UPDATE_KEY(state) {
      state.updateKey += 1;
    },

    IS_LOADING(state, bool) {
      state.isLoading = bool;
    },

    ENGAGEMENT_LOADING(state, bool) {
      state.engagementLoading = bool;
    },

    SET_ENGAGEMENTS(state, engagements) {
      state.currentEngagements = engagements;
    },
  },
}
